import type { HttpResourceRequest } from '@angular/common/http';
import { Service } from '@angular/core';
import { environment } from '@env/environment';
import { withAuth } from '@shared/utils/http-context.util';

@Service()
export class SentimentClient {
  public buildSentimentsRequest(): HttpResourceRequest {
    return {
      url: `${environment.urlApiPlatform}sentiment`,
      method: 'GET',
      ...withAuth(),
    };
  }
}
